import React from "react";
import { useTranslation } from "react-i18next";

const References = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="text-center mt-5">
        <h2>{t("auto.referencias", "Referências")}</h2>
      </div>
      <div className="mx-lg-5 text-justified">
        <p>
          {t(
            "auto.esteMaterialFoiDesenvolvidoComBaseNosDadosPublicadosPelaUniversidadeDeLiverpoolNo",
            "Este material foi desenvolvido com base nos dados publicados pela Universidade de Liverpool no",
          )}{" "}
          <a
            href="https://cancer-druginteractions.org/checker"
            target="_blank"
            rel="noreferrer noopener"
          >
            <em>
              {t("auto.cancerDrugInteractions", "Cancer Drug Interactions")}
            </em>
          </a>
          {t(
            "auto.AtualizadoEmJunhoDe2022EConsultadoA12052023",
            ", atualizado em junho de 2022, e consultado a 12/05/2023.",
          )}
        </p>
        <p>
          {t(
            "auto.foiRealizadaUmaAtualizacaoDoMaterialEmAbrilDe2026ComBaseNosDadosPublicadosNaEMA",
            "Foi realizada uma atualização do material, em Abril de 2026, com base nos dados publicados na EMA (",
          )}
          <a
            href="https://www.ema.europa.eu/"
            target="_blank"
            rel="noreferrer noopener"
          >
            <em>
              {t("auto.europeanMedicinesAgency", "European Medicines Agency")}
            </em>
          </a>
          {t("auto.consultadosA", ") e consultados a 12/03/2026. ")}
        </p>
        <p>
          {t(
            "auto.paraObterDetalhesEspecificosEConsultarAFonteOriginalAcedaA",
            "Para obter detalhes específicos e consultar a fonte original aceda a",
          )}{" "}
          <a
            href="https://cancer-druginteractions.org/view_all_interactions/16853"
            target="_blank"
            rel="noreferrer noopener"
          >
            {t(
              "auto.httpscancerdruginteractionsorgview_all_interactions16853",
              "https://cancer-druginteractions.org/view_all_interactions/16853",
            )}
          </a>
        </p>
        <p>
          {t(
            "auto.paraAlemDissoPodeTambemConsultarOsSeguintesRCMs",
            "Para além disso, pode também consultar os seguintes RCMs:",
          )}
        </p>
        <ul>
          <li className="mb-4">
            <strong>{t("auto.abemaciclib", "Abemaciclib")}</strong> -{" "}
            <a href="http://www.ema.europa.eu/en/documents/product-information/verzenios-epar-product-information_en.pdf">
              {t(
                "auto.wwwemaeuropaeuendocumentsproductinformationverzenioseparproductinformation_enpdf",
                "www.ema.europa.eu/en/documents/product-information/verzenios-epar-product-information_en.pdf",
              )}
            </a>
          </li>
          <li className="mb-4">
            <strong>{t("auto.palbociclib", "Palbociclib")}</strong> -{" "}
            <a href="http://www.ema.europa.eu/en/documents/product-information/ibrance-epar-product-information_en.pdf">
              {t(
                "auto.wwwemaeuropaeuendocumentsproductinformationibranceeparproductinformation_enpdf",
                "www.ema.europa.eu/en/documents/product-information/ibrance-epar-product-information_en.pdf",
              )}
            </a>
          </li>
          <li className="mb-4">
            <strong>{t("auto.ribociclib", "Ribociclib")}</strong> -{" "}
            <a href="http://www.ema.europa.eu/en/documents/product-information/kisqali-epar-product-information_en.pdf">
              {t(
                "auto.wwwemaeuropaeuendocumentsproductinformationkisqalieparproductinformation_enpdf",
                "www.ema.europa.eu/en/documents/product-information/kisqali-epar-product-information_en.pdf",
              )}
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default References;
